import React, { useEffect, useState } from "react";
import mail from "../assets/images/contact/mail.svg";
import fb from "../assets/images/contact/fb.svg";
import tel from "../assets/images/contact/tel.svg";
import calendar from "../assets/images/contact/calendar.svg";
import TemplateService from "../services/template";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo_kmutt.svg";
import { useParams } from "react-router-dom";

export default function Footer(props) {
  let [agencyData, setAgencyData] = useState([]);

  let { lang } = useParams();

  useEffect(() => {
    getAgencyData();
  }, []);

  const getAgencyData = async () => {
    try {
      let res = await TemplateService.getAgency();
      setAgencyData(res);
    } catch {
      console.error();
    }
  };

  return (
    <div id="footer">
      <div className="bg-darkGray3 section">
        <div className="!z-[1] navbar-container flex flex-col lg:grid lg:grid-cols-3 gap-[50px] pt-[34px] pb-[27px] flex justify-between items-start">
          <div className="col-span-2">
            <Link to={`/${lang}`}>
              <div className="flex divide-x divide-darkGray gap-[19px] py-[2px] items-center">
                <div>
                  <img className="w-[60px]" src={logo} alt="" />
                </div>
                {/* <p className="text-[28px] xl:text-[32px] text-white text-left leading-7">
                KM
                <br />
                UTT
              </p> */}
                <div className="flex flex-col mt-[15px]">
                  {props.data && props.data[0] && (
                    <p className="text-[20px] xl:text-[24px] text-white text-left leading-7 pl-[19px] whitespace-pre-line">
                      {lang === "th"
                        ? props.data[0].detail.detail_TH
                        : props.data[0].detail.detail_EN}
                    </p>
                  )}
                  {props.data && props.data[0] && (
                    <p className="text-[18px] xl:text-[16px] text-white text-left leading-7 pl-[19px] whitespace-pre-line">
                      {lang === "en"
                        ? props.data[0].detail.detail_TH
                        : props.data[0].detail.detail_EN}
                    </p>
                  )}
                </div>
              </div>
            </Link>

            <div className="grid grid-cols-3 mt-[35px] gap-[8px]">
              {agencyData &&
                agencyData.map((item, i) => (
                  <Link
                    key={i}
                    to={{ pathname: `${item.link}` }}
                    target="_blank"
                  >
                    <h1 className="text-[20px] text-white">
                      {lang === "th"
                        ? item.detail.detail_TH
                        : item.detail.detail_EN}
                    </h1>
                  </Link>
                ))}
            </div>
          </div>

          <div className="gap-[20px] col-span-1">
            <p className="text-[28px] xl:text-[32px] font-medium text-white text-left">
              {lang === "th" ? "ติดต่อเรา" : "Contact Us"}
            </p>
            <div className="flex flex-col gap-[15px] mt-[20px] pl-[15px]">
              <div className="flex gap-[13px] items-center">
                <img className="w-[26px]" src={mail} alt="" />
                {props.data && props.data[2] && (
                  <p className="whitespace-pre-line text-white text-[20px]">
                    {lang === "th"
                      ? props.data[2].detail.detail_TH
                      : props.data[2].detail.detail_EN}
                  </p>
                )}
              </div>

              <div className="flex gap-[13px] items-center">
                <img className="w-[26px]" src={fb} alt="" />
                {props.data && props.data[3] && (
                  <p className="whitespace-pre-line text-white text-[20px]">
                    {lang === "th"
                      ? props.data[3].detail.detail_TH
                      : props.data[3].detail.detail_EN}
                  </p>
                )}
              </div>

              <div className="flex gap-[13px] items-center">
                <img className="w-[26px]" src={tel} alt="" />
                {props.data && props.data[4] && (
                  <p className="whitespace-pre-line text-white text-[20px]">
                    {lang === "th"
                      ? props.data[4].detail.detail_TH
                      : props.data[4].detail.detail_EN}
                  </p>
                )}
              </div>

              <div className="flex gap-[13px] items-center">
                <img className="w-[26px]" src={calendar} alt="" />
                {props.data && props.data[5] && (
                  <p className="whitespace-pre-line text-white text-[20px]">
                    {lang === "th"
                      ? props.data[5].detail.detail_TH
                      : props.data[5].detail.detail_EN}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="bg-blue w-full text-center text-white text-[12px] xl:text-[14px] py-[3px]">
        © Copyright 2022. All Rights Reserved.
      </p>
    </div>
  );
}
